import React from 'react';
import PropTypes from 'prop-types';

import { useUserMessages } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';

import LabelTranslateWithLink from 'common/I18n/Label';

import NavigationBarItem from './NavigationBarItem';

const NavigationBarItemList = ({ isExtendedBetslipNavBar = false, links }) => {
  const { unreadMessagesCount } = useUserMessages();

  return links.map(
    ({
      altIcon,
      buttonStyle,
      defaultPath,
      icon,
      iconType,
      lightIcon,
      name,
      path,
      target,
      withNotification,
    }) => {
      const withNotificationToUse = isExtendedBetslipNavBar
        ? !!unreadMessagesCount && path === staticRoutes.menu
        : withNotification;
      const targetToUse = isExtendedBetslipNavBar ? target : '';

      return (
        <LabelTranslateWithLink
          key={path || defaultPath}
          message={name}
          render={t => (
            <NavigationBarItem
              altIcon={altIcon}
              buttonStyle={buttonStyle}
              icon={icon}
              iconType={iconType}
              label={t}
              lightIcon={lightIcon}
              link={path || defaultPath}
              target={targetToUse}
              withNotification={withNotificationToUse}
            />
          )}
        />
      );
    },
  );
};

NavigationBarItemList.propTypes = {
  isExtendedBetslipNavBar: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      defaultPath: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
};

export default NavigationBarItemList;
